var Modal = {
    "current": null,
    "init": function (el, options) {
        Modal.bindEvents(el, options);
        return this;
    },
    "bindEvents": function (el, options) {
        Modal.attachClickEvent(el, options);
        document.addEventListener('keydown', event => {
            if (event.key === 'Escape') {
                if (document.querySelector('.modal')) {
                    Modal.close(el, options);
                    Modal.destroy(el, options);
                }
            }
        });
    },
    "attachClickEvent": function (el, options) {
        el.addEventListener("click", function (event) {
            event.preventDefault();

            if (Modal.create(el, options) === true) {
                Modal.open(el, options);
            }
        });
    },
    "create": function (el, options) {

        let targetContent = el.dataset.modal;

        if (document.querySelector(targetContent) === null) {
            console.error(`Modal target element '${targetContent}' was not found.`);
            return false
        }

        var title = el.dataset.modalTitle;
        var close = el.dataset.modalHideClose;
        var type = el.dataset.modalType;
        var isAlt = el.dataset.modalAlt;


        let hasAltHeader = false;
        if (el.dataset.modalAltHeader === "true") hasAltHeader = true;

        var modalHTMLTitle = (title) ? '<div class="modal__title">' + title + '</div>' : '';
        var modalHTMLClose = (!close) ? '<span class="modal__close la la-times" data-modal-close></span>' : '';
        var modalHTMLType = (type) ? 'sidebar' : '';
        var modalHTML = '<div class="modal__inner">' + modalHTMLClose + modalHTMLTitle + '<div class="modal__content"></div></div>';

        var m = Modal.current = document.createElement("div");
        m.classList.add("modal");
        if (modalHTMLType) {
            m.classList.add("modal--sidebar");
        }
        if (hasAltHeader) {
            m.classList.add("modal--has-alt-header");
        }
        if (isAlt) {
            m.classList.add("modal--alt");
        }
        m.innerHTML = modalHTML;

        document.body.appendChild(m);

        m.addEventListener("click", function (e) {
            if (e.target !== this)
                return false;

            Modal.close(el, options);
            Modal.destroy(el, options);
        });
        return true;
    },
    "destroy": function (el, options) {
        Modal.current.parentNode.removeChild(Modal.current);
    },
    "open": function (el, options) {

        event.stopPropagation();

        let container = document.querySelector('.modal');

        container.classList.toggle('modal--open')
        Modal.addContent(el, options);

        document.querySelectorAll('[data-modal-close]').forEach(i => {
            i.addEventListener("click", function (e) {
                Modal.close(el, options);
                Modal.destroy(el, options);
            });
        });

        document.querySelector('html').classList.toggle('modal-overlay')

        if (options.onOpen !== undefined) {
            options.onOpen(container);
        }

    },
    "close": function (el, options) {
        let container = document.querySelector('.modal');

        container.classList.toggle('modal--open')
        document.querySelector('html').classList.toggle('modal-overlay');

        if (options.onClose !== undefined) {
            options.onClose(container);
        }
    },
    "addContent": function (el, options) {

        let content = el.dataset.modal;
        let contentHTML = document.querySelector(content).outerHTML;

        //de-dupe ids
        contentHTML = contentHTML.replace(/id="/g, 'id="modal-');
        contentHTML = contentHTML.replace(/for="/g, 'for="modal-');

        Modal.current.querySelector('.modal__content').innerHTML = contentHTML;

    }
};


//modal functionality
document.addEventListener('DOMContentLoaded', () => {

    //standard modal
    document.querySelectorAll("[data-modal]").forEach(el => {
        let modal = Modal.init(el, {
            "onOpen": (container) => modalOpenCallback(container)
        });

    });

});


function modalOpenCallback(container) {

    //trigger stuff
    //dropzone:
    let dropZonesWrap = container.querySelectorAll("[data-dropzone-wrap]");
    dropZonesWrap.forEach(i => triggerDropzones(i));

    //date picker
    container.querySelectorAll('[data-date-picker]').forEach(i => {
        flatpickr(i, {
            dateFormat: "d/m/Y"
        });
    });

    container.querySelectorAll("[data-select-type='choicesjs']").forEach(el => {
        if (el.closest('.modalcontent') === null) {
            let choices = new Choices(el,
                {
                    removeItemButton: true,
                    itemSelectText: "",
                    placeholderValue: "Please select...",
                    searchEnabled: false
                });
        }
    });

    //other modals
    container.querySelectorAll("[data-modal]").forEach(el => {
        let modal = Modal.init(el, {
            "onOpen": (container) => modalOpenCallback(container)
        });
    });

    //map
    container.querySelectorAll("[data-map]").forEach(el => {
        initMap(el);
    });

}